import React, { useEffect, useState } from 'react';
import DataGridTable from '../components/DataGridTable';
import Button from '@mui/material/Button';
import columns from '../components/columns/SnapshotColumns';
import {
    GridActionsCellItem,
} from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import useAppStore from "../appStore";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import CreateSnapshot from '../components/modal/createSnapshot';

const Snapshots = () => {
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [recordColumns, setRecordColumns] = useState(columns);
    const baseURL = process.env.REACT_APP_API_URL;
    const { token } = useAppStore();
    const [showModal, setShowModal] = useState(false);
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        getPosts();
    }, [])

    const getPosts = async () => {
        let posturl = baseURL + "/seller-postsearch";
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                setPosts(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const hideModal = () => {
        setShowModal(false);
    }

    useEffect(() => {
        const hasActionColumn = columns.some((col) => col.field === 'actions');
        if (!hasActionColumn) {
            const actionColumn = {
                field: 'actions',
                type: 'actions',
                headerName: 'Actions',
                width: 100,
                cellClassName: 'actions',
                getActions: ({ id }) => {
                    return [
                        <GridActionsCellItem
                            icon={<DeleteIcon />}
                            label="Delete"
                            onClick={() => handleDeleteClick(id)}
                            color="inherit"
                        />,
                    ];
                },
            };

            setRecordColumns([...columns, actionColumn]);
        }
        setLoading(false);
    }, []);


    const handleDeleteClick = async (id) => {

        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => handleDelete(id)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });


    };

    const handleDelete = async (id) => {
        let posturl = baseURL + "/seller-snapshot/" + id;
        await axios
            .delete(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(function (res) {
                console.log(res.data);
                getUsers();
                toast.success("Record has been deleted.");
            })
            .catch(function (error) {
                toast.error(error);
                console.log(error);
            });
    }

    useEffect(() => {
        getUsers();
    }, [showModal]);

    const getUsers = async () => {
        let posturl = baseURL + "/seller-snapshot";
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                setRecords(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div className='p-4 mx-4'>
            {showModal && (
                <CreateSnapshot hideModal={hideModal} posts={posts} />
            )}
            <Toaster />
            <h1 className='mt-5 text-2xl text-blue-600'>All Snapshots</h1>
            <div className='mt-10'>
                <div className='my-3 flex justify-end mr-4'>
                    <Button variant="outlined" size="small" onClick={() => { setShowModal(true) }}>Add Snapshot</Button>
                </div>
                {!loading && (
                    <DataGridTable data={records} columns={recordColumns} />
                )}
            </div>
        </div>
    );
};

export default Snapshots;
